export enum ProvisionStatus {
  NOT_FOUND = 'NOT_FOUND',
  OK = 'OK',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
}
